import { render, staticRenderFns } from "./DownloadBanner.vue?vue&type=template&id=837d3bc0&"
import script from "./DownloadBanner.vue?vue&type=script&lang=js&"
export * from "./DownloadBanner.vue?vue&type=script&lang=js&"
import style0 from "./DownloadBanner.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports